<template lang='pug'>
  div(
    v-loading='avatarLoading',
    :class='{ "has-avatar": image }'
  ).pos-r.of-h.rounded-circle.bg-white.border
    .pin.pin-center.size-100(v-if='image')
      img(:src='userAvatarUrl', alt='Avatar').size-100px.user-image.object-fit
    .pin.pin-xy.pt-1(v-else)
      svg.size-100.text-muted
        use(xlink:href='#icon-user')
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserAvatar',

  props: {
    image: { default: '', type: String },
  },

  data() {
    return {
      avatarLoading: false,
      userAvatarUrl: '',
    };
  },
  computed: {
    ...mapGetters('users', ['avatar']),
    ...mapGetters('managerole', ['userTypeName']),
  },

  watch: {
    avatar(value) {
      if (this.userTypeName === 'Support Admin') {
        this.userAvatarUrl = this.avatar.updateAvatar.userPhoto;
      }
    },
    image(val) {
      if (val) this.getUserAvatar();
    },
  },

  created() {
    if (this.image) this.getUserAvatar();
  },

  methods: {
    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', reject);
        img.src = url;
      });
    },

    getUserAvatar() {
      this.avatarLoading = true;

      this.loadImage(this.image).then((data) => {
        this.avatarLoading = false;
        this.userAvatarUrl = data.src;
      });
    },
  },
};
</script>
